import * as React from 'react';
import { withRouter } from 'react-router-dom';

const View: React.SFC<any> = props => {
  const { history } = props;

  return (
    <div className="error-page-view">
      <div className="container">
        <div className="jumbotron text-center pt-4">
          <h1>
            <span className="fa fa-exclamation-triangle" /> Oops. Page does not
            exist.
          </h1>
        </div>
      </div>
      <div className="container">
        <div className="body-content">
          <div className="text-center">
            <h4>What happened?</h4>
            <div className="lead">
              You reached a url which does not exist. Click below to go back to
              Home Page
            </div>
            <div>
              <a
                href="#"
                className="btn btn-default btn-lg text-center"
                onClick={() => {
                  history.push('/');
                }}
              >
                <span className="green">Go to Home Page</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const InvalidRoute = withRouter(View);
